import React from 'react'
import PropTypes from 'prop-types'
import { resolveLabelStatus } from './labelStatus'
import isPdfUrl from '../helpers/isPdfUrl'

// FAC-23754
// Khu vực góc phải màn Dán Label: khi scan item đầu tiên của đơn
// - Đơn đã có label (label thật hoặc tự vẽ) → hiển thị preview label
// - Đơn chưa có label VÀ không phải loại hệ thống tự vẽ → cảnh báo "Chưa có label" nhấp nháy
// - Đơn thuộc loại tự vẽ (VN/SB_FAST) → không cảnh báo
class LabelStatusPanel extends React.Component {
    state = {
        loading: false,
        hasLabel: false,
        isSystemDrawn: false,
        src: null,
    }

    // chống race khi đổi đơn liên tục: chỉ nhận kết quả của lần resolve mới nhất
    _reqId = 0

    componentDidMount() {
        this._resolve()
    }

    componentDidUpdate(prevProps) {
        const prev = prevProps.item || {}
        const curr = this.props.item || {}
        if (prev._id !== curr._id || prev.barcodeNumber !== curr.barcodeNumber) {
            this._resolve()
        }
    }

    componentWillUnmount() {
        this._reqId++
    }

    _resolve = () => {
        const { item } = this.props
        if (!item) {
            this.setState({ loading: false, hasLabel: false, isSystemDrawn: false, src: null })
            return
        }

        const current = ++this._reqId
        this.setState({ loading: true })

        resolveLabelStatus(item)
            .then(res => {
                if (current !== this._reqId) return
                this.setState({ loading: false, ...res })
            })
            .catch(() => {
                if (current !== this._reqId) return
                this.setState({ loading: false, hasLabel: false, isSystemDrawn: false, src: null })
            })
    }

    render() {
        const { item } = this.props
        if (!item) return null

        const { loading, hasLabel, isSystemDrawn, src } = this.state

        if (loading) {
            return (
                <div className="LabelStatusPanel">
                    <div className="LabelLoading">Đang tải label…</div>
                </div>
            )
        }

        if (hasLabel && src) {
            return (
                <div className="LabelStatusPanel">
                    {isPdfUrl(src)
                        ? (
                            // Label PDF không render được trong <img>, dùng iframe để xem trước
                            <iframe
                                className="LabelPreviewPdf"
                                src={`${src}#toolbar=0&navpanes=0&scrollbar=0&view=Fit`}
                                title="Label preview"
                            />
                        )
                        : <img className="LabelPreviewImage" src={src} alt="Label preview" />
                    }
                </div>
            )
        }

        if (!isSystemDrawn) {
            return (
                <div className="LabelStatusPanel">
                    <div className="LabelMissing blink">Chưa có label</div>
                </div>
            )
        }

        return null
    }
}

LabelStatusPanel.propTypes = {
    item: PropTypes.object,
}

export default LabelStatusPanel
